<app-egi-app-list
  class="fill-height border-separator-right"
  [egiApps]="egiApps$ | async"
  [active-app-id]="activeAppId"
  (select)="onSelect($event)"
></app-egi-app-list>
@if (activeApp$ | async) {
  <navigation-item-editor class="fill-height" style="overflow: auto"  [app]="activeApp$ | async">
  </navigation-item-editor>
}

@if (activeApp$ | async) {
  <egi-page-drag-list
    class="h-100 border-separator-left"
    style=" overflow: hidden"
    [activeApp]="activeApp$ | async"
  ></egi-page-drag-list>
}
